<template>
  <div id="map-legend">
    <a class="filter-collapse" @click="filterToggle = true" v-if="filterToggle === false">
      <i class="fas fa-search"></i>
    </a>
    <div class="is-expanded extended-panel lot-filter-panel" :class="{'is-active': filterToggle}">
      <button class="delete is-hidden-t" @click="filterToggle = false"></button>
      <div class="panel-header-section">
        <div class="left-item">
          <p class="panel-title">Find Your Lot</p>
          <p class="panel-subtitle" v-if="landSummary">{{ filteredLandSummary.length }} lot<span
            v-if="filteredLandSummary.length > 1">s</span> available</p>
        </div>
        <div class="right-item">
          <a class="button is-small app-highlight" @click="resetFilter()">
            RESTART
          </a>
        </div>
      </div>
      <div class="panel-body">
        <div class="filter-section">
          <div class="filter-item" v-if="filter">
            <p class="label"><small>PHASE</small></p>
            <div class="select is-small is-fullwidth">
              <select name="" id="" v-model="filter.stage" @change="filterLots()">
                <option value="" selected>All</option>
                <option v-model="filter.stage" v-for="stage in filter.stages">{{ stage }}</option>
              </select>
            </div>
          </div>

          <div class="filter-item" v-if="filter && builders.length > 1">
            <p class="label"><small>BUILDER</small></p>
            <div class="select is-small is-fullwidth">
              <select name="" v-model="filter.builder" @change="filterLots()">
                <option value="" selected>All</option>
                <option v-model="filter.builder" v-for="builder in builders">{{ builder }}</option>
              </select>
            </div>
          </div>

          <div class="filter-item" v-if="filter">
            <p class="label"><small>LOT SIZE</small></p>
            <div class="buttons has-addons">
              <button class="button" :class="{'is-active': filter.lotgroup === group}" v-for="group in lotgroups" @click="filterByLotGroup(group)">{{ group }}</button>
            </div>
          </div>

          <div id="filter-sliders" :class="{'active': landSummary.length > 0}">
<!--            <div class="filter-item price-filter-land">-->
<!--              <p class="label"><small>PRICE</small></p>-->
<!--              <input class="range-slider" type="text" id="price">-->
<!--            </div>-->

            <div class="filter-item">
              <p class="label"><small>SQUARE FOOTAGE</small></p>
              <input class="range-slider" type="text" id="area">
            </div>

            <div class="filter-item">
<!--              <p class="label"><small>FRONTAGE</small></p>-->
<!--              <input class="range-slider" type="text" id="frontage">-->
            </div>
          </div>
        </div>
        <a class="button app-highlight is-hidden-t" @click="filterToggle = false">Search</a>
        <app-land-list v-bind:landSummary="filteredLandSummary" v-on:setLotNameClick="activeLot = $event"></app-land-list>
      </div>
    </div>
  </div>
</template>

<script>

import filter from "@/model/LandFilter";
import LandList from "@/components/journey/land/LandList";

export default {

  name: 'app-map',
  mixins: [],
  components: {
    'app-land-list': LandList
  },
  props: {
    landSummary: {
      type: Array
    }
  },
  data() {
    return {
      filteredLandSummary: [],
      builders: [],
      lotgroups: [],
      filter: null,
      filterToggle: false,
      priceSlider: null,
      areaSlider: null,
      activeLot: null,
    }
  },
  watch: {
    activeLot: function (val, oldval) {
      if (val) {
        this.$emit("setActiveLot", val)
      }
    }
  },
  created() {
    let homeSelected = this.$route.query.homeid

    if (homeSelected) {
      document.getElementById('map-legend').classList.add('is-hidden')
    }
  },
  mounted() {
    if (this.landSummary.length) {
      this.filteredLandSummary = this.landSummary.filter(lot => {
        return lot.currentstatusname === 'Available'
          && lot.allocatedBuilderName
          && lot.currentstatusname !== 'sold'
          && lot.currentstatusname !== 'closed'
          && lot.currentstatusname !== 'unknown'
      })
      this.initFilter();
    }
  },
  destroyed() {
  },
  methods: {
    resetFilter: function () {
      this.filter.landAreaFrom = this.filter.landAreaMin;
      this.filter.landAreaTo = this.filter.landAreaMax;
      this.filter.builder = '';
      this.filter.lotgroup = '';
      this.filter.stage = '';
      this.areaSlider.reset();
      this.filterLots();
    },

    initFilter: function () {
      this.filter = filter;
      this.filteredLandSummary.forEach(lot => {
        if (lot.allocatedBuilderName && lot.allocatedBuilderName !== '' && !this.builders.includes(lot.allocatedBuilderName)) {
          this.builders.push(lot.allocatedBuilderName);
        }

        if (lot.lotgroup && !this.lotgroups.includes(lot.lotgroup)) {
          this.lotgroups.push(lot.lotgroup);
        }

        if (!this.filter.stages.includes(lot.stageproductname)) {
          this.filter.stages.push(lot.stageproductname);
        }

        if (lot.productsize && (this.filter.landAreaMin === 0 || lot.productsize < this.filter.landAreaMin)) {
          this.filter.landAreaMin = lot.productsize;
        }

        if (lot.productsize && (lot.productsize < this.filter.landAreaMin)) {
          this.filter.areaMin = lot.productsize;
        }


        if (lot.productsize && (this.filter.landAreaMax === 0 || lot.productsize > this.filter.landAreaMax)) {
          this.filter.landAreaMax = lot.productsize;
        }

        if (lot.productprice && (lot.productprice < this.filter.landPriceMin)) {
          this.filter.landPriceMin = lot.productprice;
        }

        if (lot.productprice && (lot.productprice > this.filter.landPriceMax)) {
          this.filter.landPriceMax = lot.productprice;
        }

        // if (lot.productwidth < this.filter.landWidthMin) {
        //   this.filter.landWidthMin = lot.productwidth;
        // }
        //
        // if (lot.productwidth > this.filter.landWidthMax) {
        //   this.filter.landWidthMax = lot.productwidth;
        // }
      });

      // this.filter.landWidthFrom = this.filter.landWidthMin;
      // this.filter.landWidthTo = this.filter.landWidthMax;
      this.filter.landPriceFrom = this.filter.landPriceMin;
      this.filter.landPriceTo = this.filter.landPriceMax;
      this.filter.landAreaFrom = this.filter.landAreaMin;
      this.filter.landAreaTo = this.filter.landAreaMax;
      this.filter.stages.sort();
      this.builders.sort();
      this.lotgroups.sort();
      this.initSliders();
    },

    initSliders: function () {
      this.areaSlider = jQuery('#area').ionRangeSlider({
        postfix: 'sqft',
        type: "double",
        min: this.filter.landAreaMin,
        max: this.filter.landAreaMax,
        from: this.filter.landAreaFrom,
        to: this.filter.landAreaTo,
        force_edges: true,
        prettify_separator: ',',
        onFinish: (data) => {
          this.filter.landAreaFrom = data.from;
          this.filter.landAreaTo = data.to;
          this.filterLots();
        },
      }).data("ionRangeSlider");
    },

    filterByLotGroup: function (group) {
      if (this.filter.lotgroup === group) {
        this.filter.lotgroup = ''
      } else {
        this.filter.lotgroup = group
      }
      this.filterLots();
    },

    filterLots: function () {
      const filteredList = [];
      this.landSummary.forEach(lot => {
        if (!lot) return;

        if (lot.currentstatusname !== 'Available') {
          return filteredList.push(lot);
        }

        if (this.filter.builder !== '' && lot.allocatedBuilderName !== this.filter.builder) {
          return;
        }

        if (this.filter.lotgroup !== '' && lot.lotgroup !== this.filter.lotgroup) {
          return;
        }

        if (this.filter.stage !== '' && lot.stageproductname !== this.filter.stage) {
          return;
        }

        if (lot.productsize && lot.productsize < this.filter.landAreaFrom) {
          return;
        }

        if (lot.productsize && lot.productsize > this.filter.landAreaTo) {
          return;
        }

        filteredList.push(lot);
      });
      this.filteredLandSummary = filteredList;
      this.$store.dispatch("setFilteredLotList", this.filteredLandSummary);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/land/LandPanel.vue